import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { UploadResponse } from '@/types/upload'
import type {
    AgentUploadConfig,
    AgentUploadParams,
    AgentUploadStrategy,
} from './agent-upload-strategy'

type UploadProgressEvent = {
    loaded?: number
    total?: number
}

export type NormalizedAgentUploadParams = Omit<AgentUploadParams, 'onProgress'> & {
    onProgress: (progress: number) => void
}

@injectable()
export class BaseAgentUploadStrategy implements AgentUploadStrategy {
    /**
     * 文件个数限制
     * @returns
     */
    async getLimit(): Promise<undefined> {
        return undefined
    }

    /**
     * 静态上传配置
     * 文件类型，max size limit
     * @returns
     */
    getUploadConfig(): AgentUploadConfig {
        return {}
    }

    normalizeParams(params: AgentUploadParams): NormalizedAgentUploadParams {
        return {
            ...params,
            onProgress: params.onProgress ?? (() => undefined),
        }
    }

    reportProgress(event: UploadProgressEvent, onProgress: (progress: number) => void) {
        if (event.total) onProgress(Math.round((event.loaded ?? 0) / event.total * 100))
    }

    createSuccessResponse<T>(data: T): UploadResponse<T> {
        return { success: true, data }
    }

    async upload(_params: AgentUploadParams): Promise<undefined> {
        return undefined
    }
}
